function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM3.773 12.099a.384.384 0 0 1-.384-.385V4.286c0-.213.172-.385.384-.385h8.454c.212 0 .384.172.384.385v4.11h-.904V4.792H4.284v4.962h.424L6.42 7.08l1.145 1.785.568.887h.493l-.815-1.271.531-.828 1.348 2.1h.543v1.875h1.25v.47h-7.71zm7.291-5.638a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0zm1.846 4.614v1.249h-.875v-1.249h-1.25v-.876h1.25V8.95h.876v1.25h1.249v.875h-1.25z"
});

var SvgIconAddImage = function SvgIconAddImage(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAddImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-add-image.8ad814a1.svg";
export { ForwardRef as ReactComponent };